import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import {
  EnableSignatureCardWrapper,
  StyledSubheader,
} from "./styledComponents";
import { Flex, Image, Box } from "rebass/styled-components";

import { StyledHeadline } from "../../../styledComponents";
import { Toggle } from "../../../../../Components/Toggle";
import { Divider } from "../../../../../Components/Divider";
import { AllstarModalState } from "../../../../../State/modals";
import { ModalType } from "../../../../../@types";
import { Success } from "../../../../../Components/Inputs";
import { StudioSession } from "../../../../../State/studioSession";
import { SignatureSelectorViewModel } from "../../../../../Components/SignatureSelector/ViewModel";
import { SignatureSelectorState } from "../../../../../State/loadoutSelector";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;
export const EnableSignature = () => {
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const [displaySuccessMessage, setDisplaySuccessMessage] = useState(false);
  const [studioSession, setStudioSession] = useRecoilState(StudioSession);
  const [signatureSession] = useRecoilState(SignatureSelectorState);
  const { toggleLoadout, getConflictingCardIds } = SignatureSelectorViewModel();
  useEffect(() => {
    if (allstarModalState?.data?.signatureSaved) {
      setDisplaySuccessMessage(true);
      setTimeout(() => {
        setDisplaySuccessMessage(false);
      }, 5000);
    }
  }, [allstarModalState?.data?.signatureSaved]);

  return (
    <EnableSignatureCardWrapper>
      <Flex
        flexDirection="row"
        justifyContent={"space-between"}
        marginLeft={"3px"}
      >
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          style={{ gap: 10 }}
        >
          <Image
            src={`${REACT_APP_S3_CLIP_BUCKET}/static/loadouts/sig.svg`}
            height={25}
            width={25}
          />
          <StyledHeadline>Signature</StyledHeadline>
        </Flex>

        <Toggle
          checked={studioSession.useSignature}
          onClick={(e: any) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          onChange={() => {
            window.rudderanalytics.track("Signature - Toggle Signature", {
              toggled: !studioSession.useSignature,
              where: !studioSession.isRemixSession ? "Studio" : "Remix",
            });
            if (!studioSession.isRemixSession) {
              //if we are toggling on the signature, we need to check for conflicting cards (studio session only)
              if (!studioSession.useSignature) {
                getConflictingCardIds({
                  variables: {
                    cardIds: signatureSession.mySignature?.clipCards.map(
                      (card) => card.card._id,
                    ),
                  },
                });
              }

              toggleLoadout({
                variables: {
                  loadoutId: signatureSession.mySignature._id,
                  active: !studioSession.useSignature,
                },
              });
            }

            setStudioSession({
              ...studioSession,
              useSignature: !studioSession.useSignature,
            });
          }}
        />
      </Flex>
      <Divider width="100%" />
      <StyledSubheader
        className="create-signature-hover"
        color="chalk"
        onClick={() => {
          window.rudderanalytics.track("Signature - Open Modal", {
            where: !studioSession.isRemixSession ? "Studio" : "Remix",
            type: "Manage",
          });
          setAllstarModalState({
            isOpen: ModalType.SignatureSelector,
            functions: {},
            data: {},
          });
        }}
      >
        Manage my Signature
      </StyledSubheader>
      {displaySuccessMessage && <Success>Signature saved!</Success>}
    </EnableSignatureCardWrapper>
  );
};
